import React from "react";
import { Modal, Button, Badge, Form } from "react-bootstrap";

const PeriodoDetalleModal = ({ show, handleClose, periodo }) => {

    const badgeVariant = (estado) => {
        return estado === 'CERRADO' ? 'secondary' : 'success';
    };

    return (
        <Modal show={show} onHide={handleClose} size="md">
            <Modal.Header closeButton>
                <Modal.Title><b>Detalle del periodo</b></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { periodo && (
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Año</Form.Label>
                            <Form.Control readOnly value={periodo.anho || periodo.anio} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Fecha inicio</Form.Label>
                            <Form.Control readOnly value={periodo.fecha_inicio || periodo.fechaInicio} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Fecha fin</Form.Label>
                            <Form.Control readOnly value={periodo.fecha_fin || periodo.fechaFin} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Estado</Form.Label>
                            <div>
                                <Badge className={periodo.estado === 'CERRADO' ? 'badge-cerrado' : 'badge-abierto'}>{periodo.estado}</Badge>
                            </div>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Fecha creación</Form.Label>
                            <Form.Control readOnly value={periodo.fecha_creacion || periodo.fechaCreacion} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Creado por</Form.Label>
                            <Form.Control readOnly value={periodo.usuario_creacion ? `${periodo.usuario_creacion.nombres} ${periodo.usuario_creacion.apellidos}` : periodo.usuarioCreacion ? `${periodo.usuarioCreacion.nombres} ${periodo.usuarioCreacion.apellidos}` : ''} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Fecha últ. actualización</Form.Label>
                            <Form.Control readOnly value={periodo.fecha_ult_modificacion} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Actualizado por</Form.Label>
                            <Form.Control readOnly value={periodo.usuario_ult_modificacion ? `${periodo.usuario_ult_modificacion.nombres} ${periodo.usuario_ult_modificacion.apellidos}` : ''} />
                        </Form.Group>
                    </Form>
                ) }
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Cerrar</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PeriodoDetalleModal;

